const BASE = "https://apihub-1sub.onrender.com/social-hub-pub";

let _cache = null;

export async function fetchBlogPosts({ force = false, limit = 100 } = {}) {
    if (_cache && !force) return _cache;

    const key = process.env.REACT_APP_SOCIAL_PUB_FEED_KEY;
    if (!key) throw new Error("REACT_APP_SOCIAL_PUB_FEED_KEY is not set");

    const res = await fetch(`${BASE}/blog/feed?limit=${limit}&include_cover_data_uri=true`, {
        headers: { Authorization: `Bearer ${key}` },
    });
    if (!res.ok) throw new Error(`Feed fetch failed: ${res.status}`);
    const { posts } = await res.json();

    _cache = posts;
    return _cache;
}

export function excerptFromMarkdown(md, maxLen = 160) {
    return md
        .replace(/#{1,6}\s+/g, "")
        .replace(/[*_`~]/g, "")
        .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
        .replace(/!\[[^\]]*\]\([^)]+\)/g, "")
        .replace(/\n+/g, " ")
        .trim()
        .slice(0, maxLen);
}
